// @flow

import React from 'react';

import './Error.scss';

type Props = {
  message: string,
}

const Error = ({ message }: Props) => (
  <div className="virtual-event__submit-result__error">
    <i className="icon-times-circle" />
    {message}
  </div>
);

export default Error;
